export default (key, code, array) => {
  for (let element in array) {
    if (array[element][key] === code) {
      return array[element].name;
    }
  }
};
